export interface PerfLogEntry {
  path: string;
  durationMs: number;
  source: 'cache' | 'server' | 'snapshot';
  timestamp: string;
  docCount: number;
}

export interface PerfMetrics {
  activeListeners: number;
  totalFirestoreReads: number;
  duplicateRequestsPrevented: number;
  requestLogs: PerfLogEntry[];
}

class FirestorePerfTracker {
  private activeListenerCount = 0;
  private totalReads = 0;
  private duplicatePrevented = 0;
  private logs: PerfLogEntry[] = [];

  registerListenerStart(path: string) {
    this.activeListenerCount++;
    console.log(`⚡ [PerfLog] Firestore Listener Registered: "${path}" | Total Active Listeners: ${this.activeListenerCount}`);
  }

  registerListenerStop(path: string) {
    this.activeListenerCount = Math.max(0, this.activeListenerCount - 1);
    console.log(`🛑 [PerfLog] Firestore Listener Unsubscribed: "${path}" | Remaining Active Listeners: ${this.activeListenerCount}`);
  }

  logFetch(path: string, durationMs: number, source: 'cache' | 'server' | 'snapshot', docCount: number = 1) {
    this.totalReads += docCount;
    const entry: PerfLogEntry = {
      path,
      durationMs: Math.round(durationMs * 10) / 10,
      source,
      timestamp: new Date().toLocaleTimeString(),
      docCount
    };
    this.logs.push(entry);
    if (this.logs.length > 200) this.logs.shift();

    console.log(`🚀 [PerfLog] Firestore Fetch: "${path}" | ${entry.durationMs}ms | ${source.toUpperCase()} | ${docCount} docs read`);
  }

  logDuplicatePrevented(path: string) {
    this.duplicatePrevented++;
    console.log(`🛡️ [PerfLog] Duplicate Firestore Subscription Multiplexed: "${path}" (Saved 1 active listener connection)`);
  }

  getMetrics(): PerfMetrics {
    return {
      activeListeners: this.activeListenerCount,
      totalFirestoreReads: this.totalReads,
      duplicateRequestsPrevented: this.duplicatePrevented,
      requestLogs: [...this.logs]
    };
  }
}

export const perfTracker = new FirestorePerfTracker();
